<template>
    <div class="wrap">
        <div class="innerBox" >
            <div v-if="this.$route.query.buyerName" class="mb20">主体名称：{{this.$route.query.buyerName}}<back></back></div>
            <div>
              <el-input placeholder="点位名称" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
              </el-input>
              <el-select class="ml20 w120" v-model="availableValue" @change="stateChange" clearable size="small" placeholder="启用状态">
                  <el-option v-for="item in availableTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div>
              <el-button class="mt20" @click="add" icon="el-icon-circle-plus-outline" type="primary">添加</el-button>
              <el-button v-if="this.tobId" class="ml20" @click="syncFromToB" type="primary">从TOB同步</el-button>
              <el-button v-if="this.togId" class="ml20" @click="syncFromToG" type="primary">从TOG同步</el-button>
              <el-button class="ml20" @click="batch('批量启用')" :disabled="isDisabled" type="primary">批量启用</el-button>
              <el-button class="ml20" @click="batch('批量禁用')" :disabled="isDisabled" type="primary">批量禁用</el-button>
              <el-button class="ml20" @click="batch('批量删除')" :disabled="isDisabled" type="primary">批量删除</el-button>
            </div>
            <div>
                <el-table :data="tableData" border style="width:calc(100% - 10px); margin-top: 10px" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading" @selection-change="handleSelectionChange">
                    <el-table-column label="序号" width="80" type="selection" >
                    </el-table-column>
                    <el-table-column prop="name" label="点位名称" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.name ? scope.row.name: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="videoUrl" label="直播地址" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.videoUrl ? scope.row.videoUrl: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="coverUrl" label="封面地址" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.coverUrl ? scope.row.coverUrl: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" label="更新时间" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.updateTime ? scope.row.updateTime: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="available" label="启用禁用" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.available ? scope.row.available: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="330">
                        <template slot-scope="scope">
                            <el-button @click="updateCover(scope.row.coverUrl, scope.row.id)" type="primary" plain size="small">传封面</el-button>
                            <el-button @click="edit(scope.row)" type="primary" plain size="small">编辑</el-button>
                            <el-button v-if="scope.row.available === '启用'" key="unAvailable" @click="useChange(scope.row)" type="danger" plain size="small">禁用</el-button>
                            <el-button v-else key="available" @click="useChange(scope.row)" type="warning" plain size="small">启用</el-button>
                            <el-button @click="del(scope.row)" type="warning" plain size="small">删除</el-button>
                        </template>
                    </el-table-column>    
                </el-table>
            </div>
            <el-dialog v-if="coverDialogVisible" :visible.sync="coverDialogVisible" :close-on-click-modal="false" title="上传封面图" style="padding-top: 0px;">
                <div class="img-upload">
                  <upload-img @getImgUrl="getCoverImgUrl" :echoImgUrl="coverUrl"></upload-img>
                </div>
                <div class="footer">
                    <el-button @click="cancleCover" round>关闭</el-button>
                    <el-button type="primary" @click="submitCover" round>保存</el-button>
                </div>
            </el-dialog>
            <el-dialog v-if="addDialogVisible" :visible.sync="addDialogVisible" :close-on-click-modal="false" :title="addTitle" style="padding-top: 0px;">
                <el-form :model="cameraAdd" :rules="dataRules" ref="cameraAdd" class="ml20 mr20" label-position="right" label-width="100px">
                    <div class="item">
                        <el-form-item label="点位名称：" prop="name">
                            <el-input class="w300" placeholder="请输入点位名称, 20字以内" maxlength="20" clearable v-model="cameraAdd.name"></el-input>
                        </el-form-item>
                        <el-form-item label="直播地址：" prop="videoUrl">
                            <el-input class="w300" type="textarea" :rows="4" placeholder="请输入直播地址, 500字以内" maxlength="500" clearable v-model="cameraAdd.videoUrl"></el-input>
                            <el-link class="click-link ml20" :disabled="isPlayabled" @click="playPreview" target="_blank">播放预览</el-link>
                        </el-form-item>
                        <el-form-item label="封面地址：" prop="coverUrl">
                            <el-input class="w300" type="textarea" :rows="4" placeholder="请输入封面地址, 500字以内, 选填" maxlength="500" clearable v-model="cameraAdd.coverUrl"></el-input>
                            <el-link class="click-link ml20" @click="updateCover(cameraAdd.coverUrl, cameraAdd.id)">上传封面图</el-link>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="footer">
                    <el-button @click="cancle" round>关闭</el-button>
                    <el-button type="primary" @click="submit('cameraAdd')" round>保存</el-button>
                </div>
            </el-dialog>
            <el-dialog class="sync-dialog" v-if="syncDialogVisible" :visible.sync="syncDialogVisible" :close-on-click-modal="false" :title="'从'+syncTitle+'同步摄像头配置'" style="padding-top: 0px;">
                <div class="sync-body">
                    <div class="left">
                        <div class="filtrate">
                            <div>{{syncTitle}}摄像头</div>
                        </div>
                        <el-table :data="leftData" height="550" border style="100%; margin-top: 10px" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="leftLoading" @selection-change="leftSelectChange" :row-key="getRowKey" ref="leftTable">
                            <el-table-column label="序号" width="80" type="selection" :reserve-selection="true" :selectable="leftSelection">
                            </el-table-column>
                            <el-table-column prop="NAME" label="点位名称" min-width="100" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.NAME ? scope.row.NAME: '-'}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="VIDEOURL" label="直播地址" min-width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.VIDEOURL ? scope.row.VIDEOURL: '-'}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="COVERURL" label="直播封面" min-width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.COVERURL ? scope.row.COVERURL: '-'}}
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <ybPagination :page="leftPage" @size-change="leftPageSizeChange" @current-change="leftPageCurrentChange" style="margin-top:10px;margin-right:10px"></ybPagination> -->
                    </div>
                    <div class="move-btn">
                        <el-button class="ml10" :disabled="isLeftDisabled" @click="moveSubtoRight" type="primary">移入右侧<i class="el-icon-d-arrow-right el-icon--right"></i></el-button>
                        <el-button class="mt20" :disabled="isRightDisabled" @click="moveSubtoLeft" type="primary" icon="el-icon-d-arrow-left">移入左侧</el-button>
                    </div>
                    <div class="right">
                        <div class="filtrate">
                            <div>当前系统配置</div>
                        </div>
                        <el-table :data="rightData" height="550" border style="width:100%; margin-top: 10px" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="rightLoading" @selection-change="rightSelectChange" :row-key="getRowKey" ref="rightTable">
                            <el-table-column label="序号" width="80" type="selection" :reserve-selection="true" :selectable="rightSelection">
                            </el-table-column>
                            <el-table-column prop="NAME" label="点位名称" min-width="100" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.NAME ? scope.row.NAME: '-'}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="VIDEOURL" label="直播地址" min-width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.VIDEOURL ? scope.row.VIDEOURL: '-'}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="COVERURL" label="直播封面" min-width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.COVERURL ? scope.row.COVERURL: '-'}}
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <ybPagination :page="rightPage" @size-change="rightPageSizeChange" @current-change="rightPageCurrentChange" style="margin-top:10px;margin-right:10px"></ybPagination> -->
                    </div>
                </div>
                <div class="mt20" style="color: red;">提示：点击保存按钮，当前主体的摄像头配置将被{{syncTitle}}摄像头配置覆盖，已绑定子食堂的摄像头将会被重置解绑！</div>
                <div class="footer">
                    <el-button @click="cancleSync" round>关闭</el-button>
                    <el-button type="primary" @click="submitSync('syncData')" round>保存</el-button>
                </div>
            </el-dialog>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px;margin-right:10px"></ybPagination>
        </div>
    </div>
</template>
<script>
import Back from '@/components/back'		//返回上一个页面按钮
import ybPagination from '@/components/ybPagination'
import UploadImg from '@/components/UploadImg'
import * as mapping from '@/utils/enumList'
import * as cameraApi from '@/api/camera'
export default {
    name: 'subjectList',
    components: {
        Back,
        ybPagination,
        UploadImg
    },
    data() {
        return {
            tobId: '',
            togId: '',
            entityId: '',
            searchInput: '',
            availableTypes: mapping.getKeyVal('available'),
            availableValue: '',
            tableLoading: false,
            tableData: [],
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 10
            },
            addDialogVisible: false,
            coverDialogVisible: false,
            subTypeValue: '',
            subTypes: mapping.getKeyVal('buyerType'),
            addTitle: '点位添加',
            dataRules: {
                name: [
                    { required: true, message: '请输入点位名称, 20字以内', trigger: 'blur' }
                ],
                videoUrl: [
                    { required: true, message: '请输入直播地址, 500字以内', trigger: 'blur' }
                ]
            },
            cameraAdd: {
                name: '',
                videoUrl: '', // 直播地址
                coverUrl: ''
            },
            coverUrl: '',
            id: '',
            idsArr: [],
            syncTitle: 'TOB',
            syncDialogVisible: false,

            leftData: [],
            leftLoading: false,
            leftIds: [],
            leftMultipleSelection: [],
            // leftPage: {
            //     pageSize: 10,
            //     pageNum: 1,
            //     total: 0
            // },

            rightData: [],
            rightTotalData: [],
            rightLoading: false,
            rightIds: [],
            rightMultipleSelection: [],
            // rightPage: {
            //     pageSize: 10,
            //     pageNum: 1,
            //     total: 0
            // },
            delIds: [],
            leftSelectHasMove: false // 标记左侧点位是否有移入右侧
        }
    },
    computed: {
        isDisabled: function() {
          return this.idsArr.length > 0 ? false : true
        },
        isPlayabled: function() {
          return this.cameraAdd.videoUrl ? false : true
        },
        queryParams: function() { 
          return {
            entityId: this.entityId,
            available: this.availableValue,
            current: this.page.pageNum,
            size: this.page.pageSize,
            keyword: this.searchInput
          }
        },
        // leftParams: function() {
        //   return {
        //       current: this.leftPage.pageNum,
        //       size: this.leftPage.pageSize,
        //   }
        // },
        isLeftDisabled: function() {
          return this.leftMultipleSelection.length > 0 ? false : true 
        },
        isRightDisabled: function() {
          return this.rightMultipleSelection.length > 0 ? false : true 
        }
    },
    methods: {
        // 搜索
        search() {
          this.page.pageNum = 1
          this.tableRefresh()
        },
        // 启用状态筛选
        stateChange(value) {
          this.page.pageNum = 1
          this.tableRefresh()
        },
        add() {
          this.addTitle = '点位添加'
          this.cameraAdd = {}
          this.addDialogVisible = true
        },
        edit(row) {
          this.addTitle = '点位编辑'
          this.addDialogVisible = true
          this.cameraAdd = row
        },
        // 批量启用/禁用
        batch(batchString) {
          this.$confirm(`是否确定${batchString}点位?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let batchPromise
            if(batchString === '批量启用') {
              batchPromise = cameraApi.batchEnable(this.idsArr)
            } else if(batchString === '批量禁用') {
              batchPromise = cameraApi.batchDisable(this.idsArr)
            } else { // 批量删除
              batchPromise = cameraApi.batchDel(this.idsArr)
            }
            batchPromise.then(res => {
              if(res.code === 200) {
                this.$message.success(`${batchString}成功`)
                this.tableRefresh()
              }
            }).catch(err => {})
          }).catch(err => {
            this.$message(`${batchString}取消`)
          })
        },
        // 多选
        handleSelectionChange(val) {
          let idsArr = []
          val.forEach(item => {
            idsArr.push(item.id)
          })
          this.idsArr = idsArr
        },
        cancle() {
          this.addDialogVisible = false
          this.tableRefresh()
        },
        submit(cameraAdd) {
          this.$refs[cameraAdd].validate((valid) => {
            if (valid) {
              let addParams = {
                entityId: this.entityId,
                id: this.addTitle === '点位添加' ? '' : this.cameraAdd.id,
                name: this.cameraAdd.name,
                videoUrl: this.cameraAdd.videoUrl,
                coverUrl: this.cameraAdd.coverUrl
              }
              let promise = this.addTitle === '点位添加' ?
                            cameraApi.cameraAdd(addParams) :
                            cameraApi.cameraUpdate(addParams)
              promise.then(res => {
                if(res.code === 200) {
                  this.$message.success(this.addTitle === '点位添加' ? '添加成功' : '编辑成功')
                  this.addDialogVisible = false
                  this.tableRefresh()
                }
              }).catch(err => {})
          }
          })
        },
        // 打开封面上传弹框
        updateCover(coverUrl, id) {
          this.id = id
          this.coverUrl = coverUrl
          this.coverDialogVisible = true
        },
        getCoverImgUrl(url) {
          this.coverUrl = url
        },
        cancleCover() {
          this.coverDialogVisible = false
        },
        // 提交上传的封面
        submitCover() {
          if(this.addDialogVisible) { // 从编辑弹框上传封面
            this.cameraAdd.coverUrl = this.coverUrl
            this.coverDialogVisible = false
          } else { // 从操作栏上传封面
            let coverParams = {
              id: this.id,
              coverUrl: this.coverUrl
            }
            cameraApi.coverUpdate(coverParams).then(res => {
              if(res.code === 200) {
                this.$message.success('上传成功')
                this.cameraAdd.coverUrl = this.coverUrl
                this.coverDialogVisible = false
                this.tableRefresh()
              }
            }).catch(err => {})
          }
        },
        // 直播地址播放预览
        playPreview() {
          let routeData = this.$router.resolve({name: 'Video', query: { src: this.cameraAdd.videoUrl}})
          window.open(routeData.href, '_blank')
        },
        // 禁用/启用
        useChange(row) {
            this.$confirm('是否确定' + (row.available === '启用'?'禁用':'启用') + '该点位?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let promise = row.available === '启用' ? 
                              cameraApi.batchDisable([row.id]) : 
                              cameraApi.batchEnable([row.id])
                promise.then(r => {
                  if(r.code === 200) {
                      this.$message.success(row.available === '禁用' ? '启用成功!':'禁用成功!')
                      this.tableRefresh();
                  }
                }).catch(err => {});
            }).catch(e => {});
        },
        del(row) {
            this.$confirm('是否确定删除该点位?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                cameraApi.batchDel([row.id]).then(r => {
                    if(r.code === 200) {
                        this.$message.success('删除成功!')
                        this.tableRefresh();
                    }
                }).catch(err => {});
            }).catch(e => {
              this.$message('删除取消')
            });
        },
        tableRefresh() {
            this.tableLoading = true;
            cameraApi.cameraList(this.queryParams).then(r => {
                if(r.code === 200) {
                    let data = r.data.records
                    data.forEach(el => {
                        el.scType = mapping.keyToVal('scType', el.scType)
                        el.buyerType = mapping.keyToVal('buyerType', el.buyerType)
                        el.available = mapping.keyToVal('available', el.available)
                        el.qualityLevel = mapping.keyToVal('qualityLevel', el.qualityLevel)
                    })
                    this.tableData = data
                    this.page.total = parseInt(r.data.total)
                }
                this.tableLoading = false;
            }).catch(err => {})
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.tableRefresh();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.tableRefresh();
            }
        },

        /**
         * 从TOB/TOG同步
         * 
        */
        clearParams() {
          this.leftIds = []
          this.leftMultipleSelection = []
          this.leftData = []
          // this.leftPage = {
          //   pageNum: 1,
          //   pageSize: 10,
          //   total: 0
          // }
          this.rightIds = []
          this.rightMultipleSelection = []

          this.rightData = []
          // 右侧列表显示当前系统配置
          if(this.tableData.length > 0) {
            this.queryParams.size = 1000
            cameraApi.cameraList(this.queryParams).then(r => {
                if(r.code === 200) {
                    let data = r.data.records
                    data.forEach(el => {
                        el.scType = mapping.keyToVal('scType', el.scType)
                        el.buyerType = mapping.keyToVal('buyerType', el.buyerType)
                        el.available = mapping.keyToVal('available', el.available)
                        el.qualityLevel = mapping.keyToVal('qualityLevel', el.qualityLevel)
                    })
                    data.forEach(item => {
                      this.rightData.push({
                        "NAME": item.name, 
                        "VIDEOURL": item.videoUrl, 
                        "COVERURL": item.coverUrl})
                    })
                }
            })
            
          }
          // 重置标记
          this.leftSelectHasMove = false
          // this.rightPage = {
          //   pageNum: 1,
          //   pageSize: 10,
          //   total: 0
          // }
          this.rightTotalData = []
        },
        syncFromToB() {
          this.clearParams()
          this.syncTitle = 'TOB'
          this.leftTableRefresh('TOB')
          this.syncDialogVisible = true
        },
        syncFromToG() {
          this.clearParams()
          this.syncTitle = 'TOG'
          this.leftTableRefresh('TOG')
          this.syncDialogVisible = true
        },
        cancleSync() {
          this.syncDialogVisible = false
        },
        submitSync() {
          if(this.leftData.length === 0) {
            this.$message.warning(this.syncTitle + '摄像头配置为空, 无法同步')
            return
          }
          if(this.rightTotalData.length === 0) {
            this.$message.warning('请将需要同步的摄像头先移入右侧, 再进行同步')
            return
          }
          let syncCameraList = []
          this.rightTotalData.forEach(item => {
            syncCameraList.push({
              'name': item.NAME ? item.NAME : '',
              'videoUrl': item.VIDEOURL ? item.VIDEOURL : '',
              'coverUrl': item.COVERURL ? item.COVERURL : '',
              'deviceId': item.deviceId,
              'type': item.type,

            })
          })
          let syncParams = {
            'cameraList': syncCameraList,
            'entityId': this.entityId
          }
          cameraApi.cameraBatchAdd(syncParams).then(res => {
            if(res.code === 200) {
              this.$message.success('同步成功')
              this.syncDialogVisible = false
              this.tableRefresh()
            }
          }).catch(err => {})
          this.syncDialogVisible = false
        },

        getRowKey(row) {
          return row.VIDEOURL
        },
        leftSelectChange(val) {
          this.leftMultipleSelection = val;
          this.leftIds = []
          if(val){
            val.forEach(item =>{
              if(item){
                this.leftIds.push(item.VIDEOURL)
              }
            })
          }
        },
        leftSelection(row, index) {
          if(!this.rightIds.length){
            return true
          }else{
            if(this.rightIds.some((item) => {
              return row.VIDEOURL === item
              }))
            {
              this.leftSelectHasMove = true
              return false;
            } else {
              return true;
            }
          }
        },
        // leftPageSizeChange(size) {
        //     if(size !== this.leftPage.pageSize) {
        //         this.leftPage.pageNum = 1;
        //         this.leftPage.pageSize = size;
        //         this.leftTableRefresh();
        //     }
        // },
        // leftPageCurrentChange(num) {
        //     if(num !== this.leftPage.pageNum) {
        //         this.leftPage.pageNum = num;
        //         this.leftTableRefresh();
        //     }
        // },
        leftTableRefresh(from) {
          this.leftLoading = true
          let leftPromise = from === 'TOB' ?
                            cameraApi.tobCameraList({tobId: this.tobId}) :
                            cameraApi.togCameraList({togId: this.togId})
          leftPromise.then(res => {
            if(res.code === 200) {
              this.leftData = from === 'TOB' ? 
                              res.data :
                              res.data.camera
              // this.leftPage.total = parseInt(r.data.total)
            }
          }).catch(err => {})
          this.leftLoading = false
        },
        
        moveSubtoRight() {
          for(let i=0; i<this.leftMultipleSelection.length; i++){
            this.rightTotalData.push(this.leftMultipleSelection[i])
          }
          this.rightTableRefresh()
          for(let i=0;i<this.leftIds.length;i++){
            this.rightIds.push(this.leftIds[i])
          }
          this.$refs.leftTable.clearSelection()
        },
        moveSubtoLeft() {
          this.rightIds = this.rightIds.filter((item)=>{
                            return this.delIds.indexOf(item) == -1
                          })
          this.rightTotalData = this.rightTotalData.filter((item)=> {
                                  return this.delIds.indexOf(item.VIDEOURL) == -1
                                })
          this.rightTableRefresh()
          this.$refs.rightTable.clearSelection()
          // if(this.rightData.length == 0){
          //     this.rightPage.pageNum = 1
          // }
          this.rightTableRefresh()
        },

        rightSelectChange(val) {
          this.rightMultipleSelection = val;
          this.delIds = []
          if(val){
            val.forEach(item =>{
              if(item){
                  this.delIds.push(item.VIDEOURL)
              }
            })
          }
        },
        rightSelection(row, index) {
          return this.leftSelectHasMove
        },
        // rightPageSizeChange(size) {
        //     if(size !== this.rightPage.pageSize) {
        //         this.rightPage.pageNum = 1;
        //         this.rightPage.pageSize = size;
        //         this.rightTableRefresh();
        //     }
        // },
        // rightPageCurrentChange(num) {
        //     if(num !== this.rightPage.pageNum) {
        //         this.rightPage.pageNum = num;
        //         this.rightTableRefresh();
        //     }
        // },
        rightTableRefresh() {
          this.rightLoading = true
          this.rightData = this.rightTotalData
          // this.rightData = []
          // let j = (this.rightPage.pageNum -1) * this.rightPage.pageSize
          // let x = this.rightPage.pageNum * this.rightPage.pageSize
          // if(x <= this.rightTotalData.length){
          //   for(let i=j;i<this.rightPage.pageSize+j;i++){
          //     this.rightData.push(this.rightTotalData[i])
          //   }
          // }else{
          //   let y = this.rightTotalData.length - j
          //   for(let i=j;i<y+j;i++){
          //       this.rightData.push(this.rightTotalData[i])
          //   }
          // }
          // this.rightPage.total = this.rightTotalData.length
          this.rightLoading = false
        }
    },
    mounted() {
        this.tobId = this.$route.query.tobId
        this.togId = this.$route.query.togId
        this.entityId = this.$route.query.entityId
        this.tableRefresh()
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
        .click-link {
          cursor: pointer;
          position: absolute;
          bottom: 0;
        }
    }
    .img-upload {
      margin-left: 60%;
      transform: translate(-60%);
    }
    .footer {
        margin-top: 20px;
        text-align: right;
    }
    .sync-dialog::v-deep .el-dialog {
        width: 1500px;
        .sync-body {
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: flex-start;
            .move-btn {
              align-self: center;
              // padding-top: 240px;
              .el-button {
                display: block;
                font-size: 16px;
                font-weight: 700;
              }
            }
        }
    }
</style>
